import { AxiosInstance } from "axios";

export interface UserGuideCloseParameters {
  cu_id: string;
}

interface UserGuideCloseResponse {
  err: string;
}

export const UserGuideClose = async (
  axios: AxiosInstance,
  { cu_id }: UserGuideCloseParameters
) => {
  const requestData = JSON.stringify({
    cu_id,
  });

  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };
  try {
    const { data } = await axios.post<UserGuideCloseResponse>(
      "api2/Warrant/UserGuideClose",
      requestData,
      { headers }
    );
    if (!data || data.err !== "0000") {
      return { err: "9999" };
    }
    return { ...data };
  } catch (error) {
    (window.parent as any).reactLogout(`登入閒置已超過20分鐘，請重新登入。 Error:${error}`);
    return { err: "9999" };
  }
};
